import * as React from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import EDMenu from '../../Menu/EDMenu';

interface IProps {
  disabled?: boolean;
  label: React.ReactNode;
  items: IButtonSelectItem[];
  selectItem: (id?: string | number) => void;
  value?: string | number;
  children?: React.ReactNode;
}

export interface IButtonSelectItem {
  label: string;
  id: string | number;
}

interface IState {
  anchorEl?: HTMLElement;
  open: boolean;
}

/**
 * Knapp som öppnar en meny med val. Används sparsamt. Oftast används snarare en MenuButton
 */
class EDButtonSelect extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      anchorEl: undefined,
      open: false,
    };
  }

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = (id?: string | number) => {
    this.setState({ open: false });
    this.props.selectItem(id);
  };

  render() {
    return (
      <span>
        <Button
          aria-owns={this.state.open ? 'simple-menu' : undefined}
          aria-haspopup={true}
          disabled={this.props.disabled}
          onClick={this.handleClick}
        >
          {this.props.label}
        </Button>
        <EDMenu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={() => this.handleRequestClose(undefined)}
          defaultValue={
            this.props.value ? this.props.value.toString() : undefined
          }
        >
          {this.props.items.map(item => (
            <MenuItem
              key={item.id}
              onClick={() => this.handleRequestClose(item.id)}
            >
              {item.label}
            </MenuItem>
          ))}
        </EDMenu>
      </span>
    );
  }
}

export default EDButtonSelect;
